import { Chip, formatDate, HelpTip } from '@dataroom/shared';
import { accessEndsSoon } from '@/lib/access-ends';

/**
 * The buyer's access end date, always visible in the room header ("Access ends
 * Nov 20, 2026"), with its help tip. Buyer access always ends on a date, so there
 * is no "stays open" wording; a session without a date (an older grant) shows
 * nothing rather than an invented one. Within a week of the end it is shown as the
 * "needs a look" chip.
 */
export function AccessEndsLine({
  accessEndsAt,
  now,
}: {
  accessEndsAt: string | undefined;
  /** For tests; defaults to the current time. */
  now?: Date;
}) {
  if (!accessEndsAt) return null;
  const date = formatDate(accessEndsAt, '');
  if (!date) return null;
  const soon = accessEndsSoon(accessEndsAt, now);
  return (
    <p
      data-testid="access-ends"
      data-soon={soon ? 'true' : 'false'}
      className="flex items-center gap-1 text-[13px] text-ink-2"
    >
      {soon ? (
        <Chip tone="check" icon="alert">
          Access ends {date}
        </Chip>
      ) : (
        <span>Access ends {date}</span>
      )}
      <HelpTip id="buyer.access.end-date" />
    </p>
  );
}
